/* tslint:disable */
/* eslint-disable */
/**
 * NETS(EFT) Hydrology API
 * \"This module contains services to maintain hydrology components  \"
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface DualSoilPctOutput
 */
export interface DualSoilPctOutput {
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'a'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'ad'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'b'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'bd'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'c'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'cd'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'd'?: number;
    /**
     * 
     * @type {string}
     * @memberof DualSoilPctOutput
     */
    'dual_soil30pct_over'?: string;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'mukey'?: number;
    /**
     * 
     * @type {number}
     * @memberof DualSoilPctOutput
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DualSoilPctResponse
 */
export interface DualSoilPctResponse {
    /**
     * 
     * @type {Array<DualSoilPctOutput>}
     * @memberof DualSoilPctResponse
     */
    'dualSoilOutput'?: Array<DualSoilPctOutput>;
    /**
     * 
     * @type {string}
     * @memberof DualSoilPctResponse
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface Efh2InputParamsDeciSSReq
 */
export interface Efh2InputParamsDeciSSReq {
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'adjustRcn'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'demServiceMetadataUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'demServiceSelected'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'dimUnitHydrogID'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'latlonInfo'?: string;
    /**
     * 
     * @type {Array<Efh2LULCInputParamsReq>}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'lulc_h'?: Array<Efh2LULCInputParamsReq>;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'practice'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'projectComments'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'projectionText'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'rainfallCellID'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'rdt_smoothing'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'runoffCN'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'scaleFeetPerInch'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'scaleType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'stormFrequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'timeC'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'user'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'watershedLen'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsDeciSSReq
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface Efh2InputParamsQuickHydroToolReq
 */
export interface Efh2InputParamsQuickHydroToolReq {
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'dimUnitHydrogID'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'manualUserInput'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'prec'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'rainfallType'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'runoffCN'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'stormFrequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'timeC'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'user'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'watershedLen'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2InputParamsQuickHydroToolReq
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface Efh2LULCInputParamsReq
 */
export interface Efh2LULCInputParamsReq {
    /**
     * 
     * @type {string}
     * @memberof Efh2LULCInputParamsReq
     */
    'hsg'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2LULCInputParamsReq
     */
    'hsg_ac'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2LULCInputParamsReq
     */
    'hsg_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2LULCInputParamsReq
     */
    'lulc'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2LULCInputParamsReq
     */
    'lulc_class'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2LULCInputParamsReq
     */
    'lulc_condition'?: string;
}
/**
 * 
 * @export
 * @interface Efh2OutputParamsDeciSSRes
 */
export interface Efh2OutputParamsDeciSSRes {
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'dimUnitHydrogID'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'fileName'?: string;
    /**
     * 
     * @type {Array<Freqs>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'freq'?: Array<Freqs>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr1'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr10'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr100'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr2'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr200'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr25'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr5'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr50'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'hydsYr500'?: Array<object>;
    /**
     * 
     * @type {Array<IaPRatios>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'ia_pRatio'?: Array<IaPRatios>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'latlonInfo'?: string;
    /**
     * 
     * @type {Array<Efh2LULCInputParamsReq>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'lulc_h'?: Array<Efh2LULCInputParamsReq>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'note'?: string;
    /**
     * 
     * @type {Array<PeakFlows>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'peakFlow'?: Array<PeakFlows>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'practice'?: string;
    /**
     * 
     * @type {Array<Precs>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'prec'?: Array<Precs>;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'rainfallCellID'?: number;
    /**
     * 
     * @type {Array<Runoffs>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'runoff'?: Array<Runoffs>;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'runoffCN'?: number;
    /**
     * 
     * @type {Array<RunoffSacfts>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'runoffSacft'?: Array<RunoffSacfts>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'statusMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'stormFrequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'timeC'?: number;
    /**
     * 
     * @type {Array<UnitPeakFlows>}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'unitPeakFlow'?: Array<UnitPeakFlows>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'user'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'watershedLen'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSRes
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface Efh2OutputParamsDeciSSResSubBasin
 */
export interface Efh2OutputParamsDeciSSResSubBasin {
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'basinName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'dimUnitHydrogID'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'frequency'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'fullHydroModel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'latLongInfo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'precipitation'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'qu'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'rainfallCellID'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'statusMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'timeOfConcentrate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'totalRunOff'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'watershedArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'watershedCN'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsDeciSSResSubBasin
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface Efh2OutputParamsQuickHydroTool
 */
export interface Efh2OutputParamsQuickHydroTool {
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'createDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'dimUnitHydrogID'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'freqList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'manualUserInput'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'peakFlowList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'practice'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'precList'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'runoffCN'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'runoffList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'statusMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'stormFrequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'timeC'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'totalRunoffList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'user'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'watershedLen'?: number;
    /**
     * 
     * @type {number}
     * @memberof Efh2OutputParamsQuickHydroTool
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface Efh2RainHydgs2
 */
export interface Efh2RainHydgs2 {
    /**
     * 
     * @type {string}
     * @memberof Efh2RainHydgs2
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2RainHydgs2
     */
    'fileType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2RainHydgs2
     */
    'fileTypeCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2RainHydgs2
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2RainHydgs2
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Efh2RainHydgs2
     */
    'uploadDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2RainHydgs2
     */
    'version'?: number;
}
/**
 * 
 * @export
 * @interface Efh2RainfallDto
 */
export interface Efh2RainfallDto {
    /**
     * 
     * @type {boolean}
     * @memberof Efh2RainfallDto
     */
    'exist'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Efh2RainfallDto
     */
    'rainFallId'?: number;
}
/**
 * 
 * @export
 * @interface Efh2RainfallExistReq
 */
export interface Efh2RainfallExistReq {
    /**
     * 
     * @type {Array<number>}
     * @memberof Efh2RainfallExistReq
     */
    'rainFallIdList'?: Array<number>;
}
/**
 * 
 * @export
 * @interface Efh2RainfallExistResp
 */
export interface Efh2RainfallExistResp {
    /**
     * 
     * @type {Array<Efh2RainfallDto>}
     * @memberof Efh2RainfallExistResp
     */
    'rainFallList'?: Array<Efh2RainfallDto>;
}
/**
 * 
 * @export
 * @interface Efh2UiStateDto
 */
export interface Efh2UiStateDto {
    /**
     * 
     * @type {string}
     * @memberof Efh2UiStateDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof Efh2UiStateDto
     */
    'uiStateTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Efh2UiStateDto
     */
    'uiStateValue'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'urlPath'?: string;
}
/**
 * 
 * @export
 * @interface FlowPathSegment
 */
export interface FlowPathSegment {
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'crossSectionalFlowArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'flowTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'manningn'?: number;
    /**
     * 
     * @type {string}
     * @memberof FlowPathSegment
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'segmentLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'segmentSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'separatorX'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'separatorY'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'subTimeOfConcentration'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'surfaceManning'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'velocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'wettedPerimeter'?: number;
}
/**
 * 
 * @export
 * @interface Freqs
 */
export interface Freqs {
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq1'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq10'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq100'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq2'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq25'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq5'?: number;
    /**
     * 
     * @type {number}
     * @memberof Freqs
     */
    'freq50'?: number;
}
/**
 * 
 * @export
 * @interface Hsg
 */
export interface Hsg {
    /**
     * 
     * @type {string}
     * @memberof Hsg
     */
    'hsgClass'?: string;
    /**
     * 
     * @type {number}
     * @memberof Hsg
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Hsg
     */
    'soilName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hsg
     */
    'soilType'?: string;
}
/**
 * 
 * @export
 * @interface HydrologyReportReqDto
 */
export interface HydrologyReportReqDto {
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'aoiMapEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'commentsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'demServiceEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'hydrographWithStrmAnlyEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'metadataEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'precpFreqDataEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HydrologyReportReqDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'rainfallDistEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HydrologyReportReqDto
     */
    'runOffPeakDisEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface IaPRatios
 */
export interface IaPRatios {
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio1'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio10'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio100'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio2'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio25'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio5'?: number;
    /**
     * 
     * @type {number}
     * @memberof IaPRatios
     */
    'ia_pRatio50'?: number;
}
/**
 * 
 * @export
 * @interface InputStreamResource
 */
export interface InputStreamResource {
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof InputStreamResource
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'filename'?: string;
    /**
     * 
     * @type {object}
     * @memberof InputStreamResource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof InputStreamResource
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputStreamResource
     */
    'readable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'uri'?: string;
    /**
     * 
     * @type {URL}
     * @memberof InputStreamResource
     */
    'url'?: URL;
}
/**
 * 
 * @export
 * @interface Lulccnlut
 */
export interface Lulccnlut {
    /**
     * 
     * @type {number}
     * @memberof Lulccnlut
     */
    'hsg_a'?: number;
    /**
     * 
     * @type {number}
     * @memberof Lulccnlut
     */
    'hsg_b'?: number;
    /**
     * 
     * @type {number}
     * @memberof Lulccnlut
     */
    'hsg_c'?: number;
    /**
     * 
     * @type {number}
     * @memberof Lulccnlut
     */
    'hsg_d'?: number;
    /**
     * 
     * @type {number}
     * @memberof Lulccnlut
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lcClass'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lcClassId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lcCondition'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lcDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lulcCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lulccnlut
     */
    'lulcCategoryId'?: string;
}
/**
 * 
 * @export
 * @interface LulccnlutFTDto
 */
export interface LulccnlutFTDto {
    /**
     * 
     * @type {number}
     * @memberof LulccnlutFTDto
     */
    'hsgA'?: number;
    /**
     * 
     * @type {number}
     * @memberof LulccnlutFTDto
     */
    'hsgB'?: number;
    /**
     * 
     * @type {number}
     * @memberof LulccnlutFTDto
     */
    'hsgC'?: number;
    /**
     * 
     * @type {number}
     * @memberof LulccnlutFTDto
     */
    'hsgD'?: number;
    /**
     * 
     * @type {string}
     * @memberof LulccnlutFTDto
     */
    'lcCondition'?: string;
    /**
     * 
     * @type {string}
     * @memberof LulccnlutFTDto
     */
    'lulcPK'?: string;
}
/**
 * 
 * @export
 * @interface LulccnlutFTDtoUp
 */
export interface LulccnlutFTDtoUp {
    /**
     * 
     * @type {Array<string>}
     * @memberof LulccnlutFTDtoUp
     */
    'lcConditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LulccnlutFTDtoUp
     */
    'lulcPK'?: string;
}
/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'absoluteFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'absolutePath'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'canonicalFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'canonicalPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'directory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'file'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'freeSpace'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'parent'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'parentFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'totalSpace'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'usableSpace'?: number;
}
/**
 * 
 * @export
 * @interface PeakFlows
 */
export interface PeakFlows {
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow1'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow10'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow100'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow2'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow25'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow5'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakFlows
     */
    'peakFlow50'?: number;
}
/**
 * 
 * @export
 * @interface Precs
 */
export interface Precs {
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec1'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec10'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec100'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec2'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec25'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec5'?: number;
    /**
     * 
     * @type {number}
     * @memberof Precs
     */
    'prec50'?: number;
}
/**
 * 
 * @export
 * @interface ProjectAttachmentDto
 */
export interface ProjectAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectFileExt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectFileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectAttachmentDto
     */
    'projectMimeTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectAttachmentDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface Rainfall
 */
export interface Rainfall {
    /**
     * 
     * @type {string}
     * @memberof Rainfall
     */
    'county'?: string;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Rainfall
     */
    'rainfallType'?: string;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'rainfall_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Rainfall
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_1'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_10'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_100'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_2'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_25'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_5'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rainfall
     */
    'yr_50'?: number;
}
/**
 * 
 * @export
 * @interface RainfallResponse
 */
export interface RainfallResponse {
    /**
     * 
     * @type {string}
     * @memberof RainfallResponse
     */
    'county'?: string;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RainfallResponse
     */
    'rainfallType'?: string;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'rainfall_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RainfallResponse
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_10'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_100'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_25'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_5'?: number;
    /**
     * 
     * @type {number}
     * @memberof RainfallResponse
     */
    'yr_50'?: number;
}
/**
 * 
 * @export
 * @interface RunoffSacfts
 */
export interface RunoffSacfts {
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft10'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft100'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft25'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft5'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSacfts
     */
    'runoffSacft50'?: number;
}
/**
 * 
 * @export
 * @interface Runoffs
 */
export interface Runoffs {
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff1'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff10'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff100'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff2'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff25'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff5'?: number;
    /**
     * 
     * @type {number}
     * @memberof Runoffs
     */
    'runoff50'?: number;
}
/**
 * 
 * @export
 * @interface StateCounty
 */
export interface StateCounty {
    /**
     * 
     * @type {string}
     * @memberof StateCounty
     */
    'county'?: string;
    /**
     * 
     * @type {number}
     * @memberof StateCounty
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StateCounty
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface TcVelocityRequestDTO
 */
export interface TcVelocityRequestDTO {
    /**
     * 
     * @type {Array<FlowPathSegment>}
     * @memberof TcVelocityRequestDTO
     */
    'flowPathSegments'?: Array<FlowPathSegment>;
    /**
     * 
     * @type {number}
     * @memberof TcVelocityRequestDTO
     */
    'rainfallDistribution'?: number;
    /**
     * 
     * @type {string}
     * @memberof TcVelocityRequestDTO
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface TcVelocityResponseDTO
 */
export interface TcVelocityResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TcVelocityResponseDTO
     */
    'averageVelocity'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TcVelocityResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<FlowPathSegment>}
     * @memberof TcVelocityResponseDTO
     */
    'flowPathSegments'?: Array<FlowPathSegment>;
    /**
     * 
     * @type {number}
     * @memberof TcVelocityResponseDTO
     */
    'timeOfConcentration'?: number;
    /**
     * 
     * @type {number}
     * @memberof TcVelocityResponseDTO
     */
    'totalLength'?: number;
}
/**
 * 
 * @export
 * @interface URI
 */
export interface URI {
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'fragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'host'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'opaque'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URI
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawAuthority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawFragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawQuery'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawSchemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawUserInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'scheme'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'schemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface URL
 */
export interface URL {
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'authority'?: string;
    /**
     * 
     * @type {object}
     * @memberof URL
     */
    'content'?: object;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'defaultPort'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'file'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'host'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'protocol'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'ref'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface UnitPeakFlows
 */
export interface UnitPeakFlows {
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow1'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow10'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow100'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow2'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow25'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow5'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnitPeakFlows
     */
    'unitPeakFlow50'?: number;
}
/**
 * 
 * @export
 * @interface Year2RainfallDTO
 */
export interface Year2RainfallDTO {
    /**
     * 
     * @type {number}
     * @memberof Year2RainfallDTO
     */
    'rainfallCellId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Year2RainfallDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof Year2RainfallDTO
     */
    'year2Rainfall'?: number;
}

/**
 * BaseControllerApi - axios parameter creator
 * @export
 */
export const BaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseControllerApi - functional programming interface
 * @export
 */
export const BaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseSvcUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseSvcUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseControllerApi - factory interface
 * @export
 */
export const BaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.baseSvcUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseControllerApi - object-oriented interface
 * @export
 * @class BaseControllerApi
 * @extends {BaseAPI}
 */
export class BaseControllerApi extends BaseAPI {
    /**
     * 
     * @summary baseSvc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseControllerApi
     */
    public baseSvcUsingGET(options?: AxiosRequestConfig) {
        return BaseControllerApiFp(this.configuration).baseSvcUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommonControllerApi - axios parameter creator
 * @export
 */
export const CommonControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingDELETE: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingHEAD: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingOPTIONS: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPATCH: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPOST: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPUT: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonControllerApi - functional programming interface
 * @export
 */
export const CommonControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingDELETE(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingDELETE(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingHEAD(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingHEAD(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingOPTIONS(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingOPTIONS(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingPATCH(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingPATCH(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingPOST(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingPOST(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async welcomeUsingPUT(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.welcomeUsingPUT(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommonControllerApi - factory interface
 * @export
 */
export const CommonControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingDELETE(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingDELETE(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingHEAD(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingHEAD(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingOPTIONS(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingOPTIONS(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPATCH(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingPATCH(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPOST(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingPOST(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary welcome
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeUsingPUT(options?: any): AxiosPromise<string> {
            return localVarFp.welcomeUsingPUT(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonControllerApi - object-oriented interface
 * @export
 * @class CommonControllerApi
 * @extends {BaseAPI}
 */
export class CommonControllerApi extends BaseAPI {
    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingDELETE(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingDELETE(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingGET(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingHEAD(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingHEAD(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingOPTIONS(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingOPTIONS(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingPATCH(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingPATCH(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingPOST(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingPOST(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary welcome
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonControllerApi
     */
    public welcomeUsingPUT(options?: AxiosRequestConfig) {
        return CommonControllerApiFp(this.configuration).welcomeUsingPUT(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * Efh2ControllerApi - axios parameter creator
 * @export
 */
export const Efh2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary copyLogFiles
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyLogFilesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/copyLogFiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET: async (fileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('downloadFileUsingGET', 'fileName', fileName)
            const localVarPath = `/api/v1/downloadFile/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLogFileUsingGET: async (logFileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logFileName' is not null or undefined
            assertParamExists('downloadLogFileUsingGET', 'logFileName', logFileName)
            const localVarPath = `/api/v1/downloadLogFile/{logFileName}`
                .replace(`{${"logFileName"}}`, encodeURIComponent(String(logFileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadSigleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSigleLogFileUsingGET: async (logFileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logFileName' is not null or undefined
            assertParamExists('downloadSigleLogFileUsingGET', 'logFileName', logFileName)
            const localVarPath = `/api/v1/downloadSingleLogFile/{logFileName}`
                .replace(`{${"logFileName"}}`, encodeURIComponent(String(logFileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadSingleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSingleLogFileUsingGET: async (logFileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logFileName' is not null or undefined
            assertParamExists('downloadSingleLogFileUsingGET', 'logFileName', logFileName)
            const localVarPath = `/api/v1/downloadHydrologyLogFile/{logFileName}`
                .replace(`{${"logFileName"}}`, encodeURIComponent(String(logFileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllCountiesByState
         * @param {string} state state
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountiesByStateUsingGET: async (state: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getAllCountiesByStateUsingGET', 'state', state)
            const localVarPath = `/api/v1/CountiesByState/{state}`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllEfh2RainHydgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEfh2RainHydgsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Efh2RainHydgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllHsgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHsgsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Hsgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllLulccnluts
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Lulccnluts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getLogFileList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogFileListUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/getLogFileList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getRainfallById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRainfallByIdUsingGET: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRainfallByIdUsingGET', 'id', id)
            const localVarPath = `/api/v1/RainfallById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary rainfallG1K
         * @param {string} newRainfallGridData newRainfallGridData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rainfallG1KUsingPOST: async (newRainfallGridData: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newRainfallGridData' is not null or undefined
            assertParamExists('rainfallG1KUsingPOST', 'newRainfallGridData', newRainfallGridData)
            const localVarPath = `/api/v1/RainfallG1K`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newRainfallGridData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Efh2ControllerApi - functional programming interface
 * @export
 */
export const Efh2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Efh2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary copyLogFiles
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyLogFilesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyLogFilesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileUsingGET(fileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileUsingGET(fileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLogFileUsingGET(logFileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadSigleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSigleLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSigleLogFileUsingGET(logFileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadSingleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSingleLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSingleLogFileUsingGET(logFileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllCountiesByState
         * @param {string} state state
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCountiesByStateUsingGET(state: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateCounty>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCountiesByStateUsingGET(state, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllEfh2RainHydgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEfh2RainHydgsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Efh2RainHydgs2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEfh2RainHydgsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllHsgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHsgsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Hsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHsgsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllLulccnluts
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLulccnlutsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lulccnlut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLulccnlutsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getLogFileList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogFileListUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogFileListUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getRainfallById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRainfallByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RainfallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRainfallByIdUsingGET(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary rainfallG1K
         * @param {string} newRainfallGridData newRainfallGridData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rainfallG1KUsingPOST(newRainfallGridData: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rainfallG1KUsingPOST(newRainfallGridData, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * Efh2ControllerApi - factory interface
 * @export
 */
export const Efh2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Efh2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary copyLogFiles
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyLogFilesUsingGET(authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.copyLogFilesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET(fileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadFileUsingGET(fileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLogFileUsingGET(logFileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadLogFileUsingGET(logFileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadSigleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSigleLogFileUsingGET(logFileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadSigleLogFileUsingGET(logFileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadSingleLogFile
         * @param {string} logFileName logFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSingleLogFileUsingGET(logFileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadSingleLogFileUsingGET(logFileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllCountiesByState
         * @param {string} state state
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCountiesByStateUsingGET(state: string, authorization?: string, options?: any): AxiosPromise<Array<StateCounty>> {
            return localVarFp.getAllCountiesByStateUsingGET(state, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllEfh2RainHydgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEfh2RainHydgsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<Efh2RainHydgs2>> {
            return localVarFp.getAllEfh2RainHydgsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllHsgs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHsgsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<Hsg>> {
            return localVarFp.getAllHsgsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllLulccnluts
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<Lulccnlut>> {
            return localVarFp.getAllLulccnlutsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getLogFileList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogFileListUsingGET(authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getLogFileListUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getRainfallById
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRainfallByIdUsingGET(id: number, authorization?: string, options?: any): AxiosPromise<RainfallResponse> {
            return localVarFp.getRainfallByIdUsingGET(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary rainfallG1K
         * @param {string} newRainfallGridData newRainfallGridData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rainfallG1KUsingPOST(newRainfallGridData: string, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.rainfallG1KUsingPOST(newRainfallGridData, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Efh2ControllerApi - object-oriented interface
 * @export
 * @class Efh2ControllerApi
 * @extends {BaseAPI}
 */
export class Efh2ControllerApi extends BaseAPI {
    /**
     * 
     * @summary copyLogFiles
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public copyLogFilesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).copyLogFilesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadFile
     * @param {string} fileName fileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public downloadFileUsingGET(fileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).downloadFileUsingGET(fileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadLogFile
     * @param {string} logFileName logFileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public downloadLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).downloadLogFileUsingGET(logFileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadSigleLogFile
     * @param {string} logFileName logFileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public downloadSigleLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).downloadSigleLogFileUsingGET(logFileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadSingleLogFile
     * @param {string} logFileName logFileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public downloadSingleLogFileUsingGET(logFileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).downloadSingleLogFileUsingGET(logFileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllCountiesByState
     * @param {string} state state
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getAllCountiesByStateUsingGET(state: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getAllCountiesByStateUsingGET(state, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllEfh2RainHydgs
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getAllEfh2RainHydgsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getAllEfh2RainHydgsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllHsgs
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getAllHsgsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getAllHsgsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllLulccnluts
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getAllLulccnlutsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getAllLulccnlutsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getLogFileList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getLogFileListUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getLogFileListUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getRainfallById
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public getRainfallByIdUsingGET(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).getRainfallByIdUsingGET(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary rainfallG1K
     * @param {string} newRainfallGridData newRainfallGridData
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Efh2ControllerApi
     */
    public rainfallG1KUsingPOST(newRainfallGridData: string, authorization?: string, options?: AxiosRequestConfig) {
        return Efh2ControllerApiFp(this.configuration).rainfallG1KUsingPOST(newRainfallGridData, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydroControllerApi - axios parameter creator
 * @export
 */
export const HydroControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary downloadEfh2Details
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEfh2DetailsUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('downloadEfh2DetailsUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/api/v2/downloadEfh2DetailsZip/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadEfh2PdfReports
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEfh2PdfReportsUsingPOST: async (hydReportDto: HydrologyReportReqDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydReportDto' is not null or undefined
            assertParamExists('downloadEfh2PdfReportsUsingPOST', 'hydReportDto', hydReportDto)
            const localVarPath = `/api/v2/generateEfh2PdfReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateEfh2PdfReportsCL
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEfh2PdfReportsCLUsingPOST: async (hydReportDto: HydrologyReportReqDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydReportDto' is not null or undefined
            assertParamExists('generateEfh2PdfReportsCLUsingPOST', 'hydReportDto', hydReportDto)
            const localVarPath = `/api/v2/generateEfh2PdfReportsCL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateEfh2PdfReportsG
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEfh2PdfReportsGUsingPOST: async (hydReportDto: HydrologyReportReqDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydReportDto' is not null or undefined
            assertParamExists('generateEfh2PdfReportsGUsingPOST', 'hydReportDto', hydReportDto)
            const localVarPath = `/api/v2/generateEfh2PdfReportsG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateNOAACSVFile
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNOAACSVFileUsingPOST: async (inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputParmsSSReq' is not null or undefined
            assertParamExists('generateNOAACSVFileUsingPOST', 'inputParmsSSReq', inputParmsSSReq)
            const localVarPath = `/api/v2/generateNOAACSVFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParmsSSReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWinTR20ResultsCountyLevel
         * @param {Efh2InputParamsDeciSSReq} inputParmsCLReq inputParmsCLReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsCountyLevelUsingPOST: async (inputParmsCLReq: Efh2InputParamsDeciSSReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputParmsCLReq' is not null or undefined
            assertParamExists('generateWinTR20ResultsCountyLevelUsingPOST', 'inputParmsCLReq', inputParmsCLReq)
            const localVarPath = `/api/v2/generateWinTR20ResultsCountyLevel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParmsCLReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWinTR20ResultsG
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsGUsingPOST: async (inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputParmsSSReq' is not null or undefined
            assertParamExists('generateWinTR20ResultsGUsingPOST', 'inputParmsSSReq', inputParmsSSReq)
            const localVarPath = `/api/v2/generateWinTR20ResultsG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParmsSSReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWinTR20ResultsQuickHydroTool
         * @param {Efh2InputParamsQuickHydroToolReq} efh2InputParamsQuickHydroToolReq efh2InputParamsQuickHydroToolReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsQuickHydroToolUsingPOST: async (efh2InputParamsQuickHydroToolReq: Efh2InputParamsQuickHydroToolReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'efh2InputParamsQuickHydroToolReq' is not null or undefined
            assertParamExists('generateWinTR20ResultsQuickHydroToolUsingPOST', 'efh2InputParamsQuickHydroToolReq', efh2InputParamsQuickHydroToolReq)
            const localVarPath = `/api/v2/generateWinTR20ResultsQuickHydroTool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(efh2InputParamsQuickHydroToolReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecificSubBasin
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsSiteSpecificSubBasinUsingPOST: async (inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputParmsSSReq' is not null or undefined
            assertParamExists('generateWinTR20ResultsSiteSpecificSubBasinUsingPOST', 'inputParmsSSReq', inputParmsSSReq)
            const localVarPath = `/api/v2/generateWinTR20ResultsSiteSpecificSubBasin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParmsSSReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecific
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsSiteSpecificUsingPOST: async (inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputParmsSSReq' is not null or undefined
            assertParamExists('generateWinTR20ResultsSiteSpecificUsingPOST', 'inputParmsSSReq', inputParmsSSReq)
            const localVarPath = `/api/v2/generateWinTR20ResultsSiteSpecific`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParmsSSReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get2YearRainfallDistributionByRainfallCellId
         * @param {number} rainfallCellId rainfallCellId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2YearRainfallDistributionByRainfallCellIdUsingGET: async (rainfallCellId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rainfallCellId' is not null or undefined
            assertParamExists('get2YearRainfallDistributionByRainfallCellIdUsingGET', 'rainfallCellId', rainfallCellId)
            const localVarPath = `/api/v2/get2YearRainfallDistributionByRainfallCellId/{rainfallCellId}`
                .replace(`{${"rainfallCellId"}}`, encodeURIComponent(String(rainfallCellId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllLulccnlutsForFTUp
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsForFTUpUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/lulccnlutsForFtUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllLulccnlutsForFT
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsForFTUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/lulccnlutsForFt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCountyRegionRainfallDataByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountyRegionRainfallDataByStateUsingGET: async (stateCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getCountyRegionRainfallDataByStateUsingGET', 'stateCode', stateCode)
            const localVarPath = `/api/v2/getCountyRegionRainfallDataByState/{stateCode}`
                .replace(`{${"stateCode"}}`, encodeURIComponent(String(stateCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDualSoilPctByMukeys
         * @param {string} mukeyList mukeyList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDualSoilPctByMukeysUsingPOST: async (mukeyList: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mukeyList' is not null or undefined
            assertParamExists('getDualSoilPctByMukeysUsingPOST', 'mukeyList', mukeyList)
            const localVarPath = `/api/v2/getDualSoilPctByMukeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mukeyList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getHydroProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroProjectAttachmentsByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getHydroProjectAttachmentsByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/api/v2/getHydroProjectAttachmentsByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary isRainFallDataExists
         * @param {Efh2RainfallExistReq} rainfallExistReq rainfallExistReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isRainFallDataExistsUsingPOST: async (rainfallExistReq: Efh2RainfallExistReq, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rainfallExistReq' is not null or undefined
            assertParamExists('isRainFallDataExistsUsingPOST', 'rainfallExistReq', rainfallExistReq)
            const localVarPath = `/api/v2/isRainFallDataExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rainfallExistReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateHydroUiStateByProjectUuid
         * @param {Efh2UiStateDto} efh2UiStateDto efh2UiStateDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHydroUiStateByProjectUuidUsingPOST: async (efh2UiStateDto: Efh2UiStateDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'efh2UiStateDto' is not null or undefined
            assertParamExists('updateHydroUiStateByProjectUuidUsingPOST', 'efh2UiStateDto', efh2UiStateDto)
            const localVarPath = `/api/v2/updateHydroUiStateByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(efh2UiStateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydroControllerApi - functional programming interface
 * @export
 */
export const HydroControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydroControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary downloadEfh2Details
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEfh2DetailsUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEfh2DetailsUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadEfh2PdfReports
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEfh2PdfReportsUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEfh2PdfReportsUsingPOST(hydReportDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateEfh2PdfReportsCL
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateEfh2PdfReportsCLUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateEfh2PdfReportsCLUsingPOST(hydReportDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateEfh2PdfReportsG
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateEfh2PdfReportsGUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateEfh2PdfReportsGUsingPOST(hydReportDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateNOAACSVFile
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateNOAACSVFileUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateNOAACSVFileUsingPOST(inputParmsSSReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWinTR20ResultsCountyLevel
         * @param {Efh2InputParamsDeciSSReq} inputParmsCLReq inputParmsCLReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2OutputParamsDeciSSRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWinTR20ResultsG
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWinTR20ResultsGUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2OutputParamsDeciSSRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWinTR20ResultsGUsingPOST(inputParmsSSReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWinTR20ResultsQuickHydroTool
         * @param {Efh2InputParamsQuickHydroToolReq} efh2InputParamsQuickHydroToolReq efh2InputParamsQuickHydroToolReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq: Efh2InputParamsQuickHydroToolReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2OutputParamsQuickHydroTool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecificSubBasin
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2OutputParamsDeciSSResSubBasin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecific
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2OutputParamsDeciSSRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get2YearRainfallDistributionByRainfallCellId
         * @param {number} rainfallCellId rainfallCellId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Year2RainfallDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllLulccnlutsForFTUp
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLulccnlutsForFTUpUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LulccnlutFTDtoUp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLulccnlutsForFTUpUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllLulccnlutsForFT
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLulccnlutsForFTUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LulccnlutFTDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLulccnlutsForFTUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCountyRegionRainfallDataByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountyRegionRainfallDataByStateUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rainfall>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountyRegionRainfallDataByStateUsingGET(stateCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDualSoilPctByMukeys
         * @param {string} mukeyList mukeyList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDualSoilPctByMukeysUsingPOST(mukeyList: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DualSoilPctResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDualSoilPctByMukeysUsingPOST(mukeyList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getHydroProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary isRainFallDataExists
         * @param {Efh2RainfallExistReq} rainfallExistReq rainfallExistReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isRainFallDataExistsUsingPOST(rainfallExistReq: Efh2RainfallExistReq, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Efh2RainfallExistResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isRainFallDataExistsUsingPOST(rainfallExistReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateHydroUiStateByProjectUuid
         * @param {Efh2UiStateDto} efh2UiStateDto efh2UiStateDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto: Efh2UiStateDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydroControllerApi - factory interface
 * @export
 */
export const HydroControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydroControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary downloadEfh2Details
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEfh2DetailsUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadEfh2DetailsUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadEfh2PdfReports
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEfh2PdfReportsUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadEfh2PdfReportsUsingPOST(hydReportDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateEfh2PdfReportsCL
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEfh2PdfReportsCLUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.generateEfh2PdfReportsCLUsingPOST(hydReportDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateEfh2PdfReportsG
         * @param {HydrologyReportReqDto} hydReportDto hydReportDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEfh2PdfReportsGUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.generateEfh2PdfReportsGUsingPOST(hydReportDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateNOAACSVFile
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNOAACSVFileUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateNOAACSVFileUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWinTR20ResultsCountyLevel
         * @param {Efh2InputParamsDeciSSReq} inputParmsCLReq inputParmsCLReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: any): AxiosPromise<Efh2OutputParamsDeciSSRes> {
            return localVarFp.generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWinTR20ResultsG
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsGUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: any): AxiosPromise<Efh2OutputParamsDeciSSRes> {
            return localVarFp.generateWinTR20ResultsGUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWinTR20ResultsQuickHydroTool
         * @param {Efh2InputParamsQuickHydroToolReq} efh2InputParamsQuickHydroToolReq efh2InputParamsQuickHydroToolReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq: Efh2InputParamsQuickHydroToolReq, authorization?: string, options?: any): AxiosPromise<Efh2OutputParamsQuickHydroTool> {
            return localVarFp.generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecificSubBasin
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: any): AxiosPromise<Efh2OutputParamsDeciSSResSubBasin> {
            return localVarFp.generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWinTR20ResultsSiteSpecific
         * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: any): AxiosPromise<Efh2OutputParamsDeciSSRes> {
            return localVarFp.generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get2YearRainfallDistributionByRainfallCellId
         * @param {number} rainfallCellId rainfallCellId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId: number, authorization?: string, options?: any): AxiosPromise<Year2RainfallDTO> {
            return localVarFp.get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllLulccnlutsForFTUp
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsForFTUpUsingGET(authorization?: string, options?: any): AxiosPromise<Array<LulccnlutFTDtoUp>> {
            return localVarFp.getAllLulccnlutsForFTUpUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllLulccnlutsForFT
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLulccnlutsForFTUsingGET(authorization?: string, options?: any): AxiosPromise<Array<LulccnlutFTDto>> {
            return localVarFp.getAllLulccnlutsForFTUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCountyRegionRainfallDataByState
         * @param {string} stateCode stateCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountyRegionRainfallDataByStateUsingGET(stateCode: string, authorization?: string, options?: any): AxiosPromise<Array<Rainfall>> {
            return localVarFp.getCountyRegionRainfallDataByStateUsingGET(stateCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDualSoilPctByMukeys
         * @param {string} mukeyList mukeyList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDualSoilPctByMukeysUsingPOST(mukeyList: string, authorization?: string, options?: any): AxiosPromise<DualSoilPctResponse> {
            return localVarFp.getDualSoilPctByMukeysUsingPOST(mukeyList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getHydroProjectAttachmentsByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ProjectAttachmentDto>> {
            return localVarFp.getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary isRainFallDataExists
         * @param {Efh2RainfallExistReq} rainfallExistReq rainfallExistReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isRainFallDataExistsUsingPOST(rainfallExistReq: Efh2RainfallExistReq, authorization?: string, options?: any): AxiosPromise<Efh2RainfallExistResp> {
            return localVarFp.isRainFallDataExistsUsingPOST(rainfallExistReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateHydroUiStateByProjectUuid
         * @param {Efh2UiStateDto} efh2UiStateDto efh2UiStateDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto: Efh2UiStateDto, authorization?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydroControllerApi - object-oriented interface
 * @export
 * @class HydroControllerApi
 * @extends {BaseAPI}
 */
export class HydroControllerApi extends BaseAPI {
    /**
     * 
     * @summary downloadEfh2Details
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public downloadEfh2DetailsUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).downloadEfh2DetailsUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadEfh2PdfReports
     * @param {HydrologyReportReqDto} hydReportDto hydReportDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public downloadEfh2PdfReportsUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).downloadEfh2PdfReportsUsingPOST(hydReportDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateEfh2PdfReportsCL
     * @param {HydrologyReportReqDto} hydReportDto hydReportDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateEfh2PdfReportsCLUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateEfh2PdfReportsCLUsingPOST(hydReportDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateEfh2PdfReportsG
     * @param {HydrologyReportReqDto} hydReportDto hydReportDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateEfh2PdfReportsGUsingPOST(hydReportDto: HydrologyReportReqDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateEfh2PdfReportsGUsingPOST(hydReportDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateNOAACSVFile
     * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateNOAACSVFileUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateNOAACSVFileUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWinTR20ResultsCountyLevel
     * @param {Efh2InputParamsDeciSSReq} inputParmsCLReq inputParmsCLReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateWinTR20ResultsCountyLevelUsingPOST(inputParmsCLReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWinTR20ResultsG
     * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateWinTR20ResultsGUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateWinTR20ResultsGUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWinTR20ResultsQuickHydroTool
     * @param {Efh2InputParamsQuickHydroToolReq} efh2InputParamsQuickHydroToolReq efh2InputParamsQuickHydroToolReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq: Efh2InputParamsQuickHydroToolReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateWinTR20ResultsQuickHydroToolUsingPOST(efh2InputParamsQuickHydroToolReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWinTR20ResultsSiteSpecificSubBasin
     * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateWinTR20ResultsSiteSpecificSubBasinUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWinTR20ResultsSiteSpecific
     * @param {Efh2InputParamsDeciSSReq} inputParmsSSReq inputParmsSSReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq: Efh2InputParamsDeciSSReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).generateWinTR20ResultsSiteSpecificUsingPOST(inputParmsSSReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get2YearRainfallDistributionByRainfallCellId
     * @param {number} rainfallCellId rainfallCellId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId: number, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).get2YearRainfallDistributionByRainfallCellIdUsingGET(rainfallCellId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllLulccnlutsForFTUp
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getAllLulccnlutsForFTUpUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getAllLulccnlutsForFTUpUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllLulccnlutsForFT
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getAllLulccnlutsForFTUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getAllLulccnlutsForFTUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCountyRegionRainfallDataByState
     * @param {string} stateCode stateCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getCountyRegionRainfallDataByStateUsingGET(stateCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getCountyRegionRainfallDataByStateUsingGET(stateCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDualSoilPctByMukeys
     * @param {string} mukeyList mukeyList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getDualSoilPctByMukeysUsingPOST(mukeyList: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getDualSoilPctByMukeysUsingPOST(mukeyList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getHydroProjectAttachmentsByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getHydroProjectAttachmentsByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary isRainFallDataExists
     * @param {Efh2RainfallExistReq} rainfallExistReq rainfallExistReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public isRainFallDataExistsUsingPOST(rainfallExistReq: Efh2RainfallExistReq, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).isRainFallDataExistsUsingPOST(rainfallExistReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateHydroUiStateByProjectUuid
     * @param {Efh2UiStateDto} efh2UiStateDto efh2UiStateDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto: Efh2UiStateDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).updateHydroUiStateByProjectUuidUsingPOST(efh2UiStateDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydroTcVelocityControllerApi - axios parameter creator
 * @export
 */
export const HydroTcVelocityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to calculate time of concentration and velocity
         * @param {TcVelocityRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateVelocityAndTimeOfConcentrationUsingPOST: async (request: TcVelocityRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateVelocityAndTimeOfConcentrationUsingPOST', 'request', request)
            const localVarPath = `/calculateVelocityAndTimeOfConcentration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydroTcVelocityControllerApi - functional programming interface
 * @export
 */
export const HydroTcVelocityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydroTcVelocityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to calculate time of concentration and velocity
         * @param {TcVelocityRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateVelocityAndTimeOfConcentrationUsingPOST(request: TcVelocityRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TcVelocityResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateVelocityAndTimeOfConcentrationUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydroTcVelocityControllerApi - factory interface
 * @export
 */
export const HydroTcVelocityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydroTcVelocityControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to calculate time of concentration and velocity
         * @param {TcVelocityRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateVelocityAndTimeOfConcentrationUsingPOST(request: TcVelocityRequestDTO, authorization?: string, options?: any): AxiosPromise<TcVelocityResponseDTO> {
            return localVarFp.calculateVelocityAndTimeOfConcentrationUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydroTcVelocityControllerApi - object-oriented interface
 * @export
 * @class HydroTcVelocityControllerApi
 * @extends {BaseAPI}
 */
export class HydroTcVelocityControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to calculate time of concentration and velocity
     * @param {TcVelocityRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroTcVelocityControllerApi
     */
    public calculateVelocityAndTimeOfConcentrationUsingPOST(request: TcVelocityRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydroTcVelocityControllerApiFp(this.configuration).calculateVelocityAndTimeOfConcentrationUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringControllerApi - axios parameter creator
 * @export
 */
export const MonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringControllerApi - functional programming interface
 * @export
 */
export const MonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck2UsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck2UsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringControllerApi - factory interface
 * @export
 */
export const MonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.healthCheck2UsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringControllerApi - object-oriented interface
 * @export
 * @class MonitoringControllerApi
 * @extends {BaseAPI}
 */
export class MonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @summary healthCheck2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringControllerApi
     */
    public healthCheck2UsingGET(options?: AxiosRequestConfig) {
        return MonitoringControllerApiFp(this.configuration).healthCheck2UsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceStatusControllerApi - axios parameter creator
 * @export
 */
export const ServiceStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/entityCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck_core`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/profileCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatusControllerApi - functional programming interface
 * @export
 */
export const ServiceStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckCoreUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckCoreUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceStatusControllerApi - factory interface
 * @export
 */
export const ServiceStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.entityCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckCoreUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.profileCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatusControllerApi - object-oriented interface
 * @export
 * @class ServiceStatusControllerApi
 * @extends {BaseAPI}
 */
export class ServiceStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary entityCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public entityCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).entityCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary healthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public healthCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).healthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck_core
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckCoreUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckCoreUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary profileCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public profileCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).profileCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * Tr20ControllerApi - axios parameter creator
 * @export
 */
export const Tr20ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getTR20ResultsJsonByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTR20ResultsJsonByProjectUuidUsingGET: async (projectUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getTR20ResultsJsonByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/tr20/getTR20ResultsJsonByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Tr20ControllerApi - functional programming interface
 * @export
 */
export const Tr20ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Tr20ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getTR20ResultsJsonByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * Tr20ControllerApi - factory interface
 * @export
 */
export const Tr20ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Tr20ControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getTR20ResultsJsonByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Tr20ControllerApi - object-oriented interface
 * @export
 * @class Tr20ControllerApi
 * @extends {BaseAPI}
 */
export class Tr20ControllerApi extends BaseAPI {
    /**
     * 
     * @summary getTR20ResultsJsonByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Tr20ControllerApi
     */
    public getTR20ResultsJsonByProjectUuidUsingGET(projectUuid: string, options?: AxiosRequestConfig) {
        return Tr20ControllerApiFp(this.configuration).getTR20ResultsJsonByProjectUuidUsingGET(projectUuid, options).then((request) => request(this.axios, this.basePath));
    }
}


